import { render, staticRenderFns } from "./CommentDetails.vue?vue&type=template&id=3ea933ee&"
import script from "./CommentDetails.vue?vue&type=script&lang=js&"
export * from "./CommentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports